export default "__VITE_ASSET__BIWbCUps__"